import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { HorizontalLayout, Content, Sidebar, MenuItem } from '../common'
import ReduxStateTab from './redux/ReduxStateTab'
import ReduxActionsTab from './redux/ReduxActionsTab'
import { useSessionPersistedTabs } from '../hooks'

const TAB_STORAGE_KEY = 'DevPanel:redux:selectedTab'

function ReduxTab() {
  const intl = useIntl()
  const tabs = useMemo(() => ([
    {
      id: 'currentState',
      label: intl.formatMessage({
        id: 'Ix3J4jr4Ec38G2FAWZbP',
        defaultMessage: 'Current state',
      }),
      component: ReduxStateTab,
    },
    {
      id: 'actions',
      label: intl.formatMessage({
        id: 'uNv1Z1wNseYfDVgwM8uJ',
        defaultMessage: 'Actions',
      }),
      component: ReduxActionsTab,
    },
  ] as const), [intl])
  const tabIds = tabs.map(tab => tab.id)
  const [currentTabId, setTab] = useSessionPersistedTabs(tabIds, TAB_STORAGE_KEY)

  const currentTab = tabs.find(tab => tab.id === currentTabId)!
  const TabContent = currentTab.component

  return <HorizontalLayout>
    <Sidebar>
      {tabs.map(tab => (
        <MenuItem key={tab.id} onClick={setTab[tab.id]} title={tab.label} selected={tab.id === currentTabId} />
      ))}
    </Sidebar>

    <Content>
      <TabContent />
    </Content>
  </HorizontalLayout>
}

export default ReduxTab
